import React from 'react';
import { useIntl } from 'react-intl';

import { GIButton, Modal } from 'app-components';

import { ITerminationModalProps } from '../common/types';
import { MODAL_KEYS } from './modalKeys';

const TerminationModal = ({ closeModal, onContinueClick, isTermination }: ITerminationModalProps) => {
    const intl = useIntl();

    return (
        <Modal id={MODAL_KEYS.TERMINATION} data-testid="termination-modal">
            <Modal.Header
                id="termination-modal-header"
                titleId={
                    isTermination
                        ? 'member.enrollment_list.premiumhistory.terminationModal.heading'
                        : 'member.enrollment_list.premiumhistory.selectionModal.heading'
                }
                onHide={closeModal}
            />
            <Modal.Body data-testid="termination-modal-body">
                <p>
                    {intl.formatMessage({
                        id: isTermination
                            ? 'member.enrollment_list.premiumhistory.terminationModal.message'
                            : 'member.enrollment_list.premiumhistory.selectionModal.message',
                    })}
                </p>
            </Modal.Body>
            <Modal.Controls data-testid="termination-modal-controls">
                <GIButton
                    id="termination-cancel-button"
                    onClickHandler={closeModal}
                    variant="secondary"
                    labelId="button.cancel"
                    data-testid="termination-cancel-button"
                />
                <GIButton
                    id="termination-continue-button"
                    onClickHandler={onContinueClick}
                    variant="primary"
                    labelId="button.continue"
                    data-testid="termination-continue-button"
                />
            </Modal.Controls>
        </Modal>
    );
};

export default TerminationModal;
